module.exports = __webpack_public_path__ + "img/shield-icon.77c853ac.svg";